import Collection from '@models/Collection'
import { Author } from '@models/Title'

import { Currency } from './commerce/Price'

export default interface Product {
  // Product formatter
  /** @deprecated duplicate of `uuid` */
  id: string
  sellable_arrangements: boolean
  author: Author | null
  author_id: string
  seller_id: number
  publisher_name: string
  average_rating: number
  cover_art_url: string
  cover_art_id: number | null
  cover_art_directive: string | null
  created: number
  created_at: string
  currency: Currency | null
  description: string | null
  ensemble_size_max: number | null
  ensemble_size_name: string | null
  /** @deprecated duplicate of `uuid` */
  external_id: string
  has_audio_preview: boolean
  has_custom_audio_media: boolean
  marketplace_url: string
  music_url: string
  is_arrange_me: boolean
  metadata: unknown
  official: boolean
  object_type: 'product'
  price: number | null
  slug: string | null
  status: string | null
  title: string | null
  type: string | null
  updated: number
  uuid: string
  views_count: number
  preview_type: ProductPreviewType | null
  minimum_initial_purchase_amount: number
  source_score_id: string
  document_role_ids: unknown[]

  // Optional attributes
  contributors?: unknown[]
  audio_preview_url?: string | null
  embed_url?: string
  preview_url?: string
  full_marketplace_url?: string
  score_signed_url?: string
  format?: string
  collections?: Collection[]
  favorites_count?: number
  reviews_count?: number
  has_been_purchased?: boolean
  song_id?: string
  song?: unknown
  admin_song?: unknown
  source_product_id?: string | null
  purchased_quantity?: number
  authorized_name?: string | null
  number_accessors_used?: number | null
  in_favorites?: boolean
  seller_account?: unknown
  dam_asset?: unknown | null
  admin_url?: string
}

export enum ProductPreviewType {
  PARTIAL = 'partial',
  FULL = 'full',
}

export interface AuthorizedPerformersOption {
  value: number
  label: string
}

export const TWENTY_ONE_PLUS_AUTHORIZED_PERFORMERS = 'overTwenty'
